export default "__VITE_ASSET__B0xMGxu8__"